module.exports = __webpack_public_path__ + "img/scale.0b7af767.svg";